import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {dimensionKindZaun,
       updateTotalWidthZaun,
       updateSingleTotalDimensionZaun,
       updateSingleDimensionZaun,
       addSingleTextFieldZaun,
       updateSingleFieldDimensionZaun,
       deleteSingleFiledZaun,
       updateStepsZaun,
       updateHeightZaun
      } from '../../../../store/actions/zaune';
import TextField from '@material-ui/core/TextField';
import {InputRadio} from '../../../../module/inputRadio';
import {Textfield} from '../../../../module/textField';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import scrollToElement from '../../../../module/scrollToElement';


const Step_2 = (props) => {
   let [dimension, selectDimension] = useState('');
   let [total_dimension_width, selectTotalDimensionWidth] = useState('');
   let [total_dimension_height, selectTotalDimensionHeight] = useState('');
   let [kind_dimension, selectKindDimension] = useState('');
   let [single_width, selectSingleWidth] = useState('');
   let [single_piece, selectSinglePiece] = useState('');
   let [single_fields, selectSingleFields] = useState('');

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      const {dimension,
            total_dimension_width,
            total_dimension_height,
            kind_dimension,
            single_width,
            single_piece,
            single_fields} = props.data.dimensions[0];

      selectDimension(dimension);
      selectTotalDimensionWidth(total_dimension_width);
      selectTotalDimensionHeight(total_dimension_height);
      selectKindDimension(kind_dimension);
      selectSingleWidth(single_width);
      selectSinglePiece(single_piece);
      selectSingleFields(single_fields);

      //scroll to Next Button Container
      if (dimension === 'Gesamt'||kind_dimension) scrollToElement();

      //update steps
      props.updateStepsZaun(1);

      if ((total_dimension_height > 0 && total_dimension_width > 0)
         || (total_dimension_height > 0 && single_width > 0 && single_piece > 0)
         || props.data.allVisitedSteps
         ) {
         props.updateStepsZaun(2);
         props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue();
      }

   }

 const selectKindOfDimension = ev => {
     props.dimensionKind(ev.target.value);
     updateItems();
 }

 const updateTotalWidth = ev => {
      let total_width_value = ev.target.value
      props.updateTotalWidth(total_width_value);
      updateItems();
 }

 const updateSingleTotalDimension = ev => {
      props.updateSingleTotalDimension(ev.target.value);
      updateItems();
 }

 const updateSingleDimension = ev => {
    let singleDimensionObject = {
       name: ev.currentTarget.getAttribute('name'),
       value: ev.target.value
    }
     props.updateSingleDimension(singleDimensionObject);
     props.updateTotalWidth();
     updateItems();
 }

 const addSingleTextField = () => {
    props.addSingleTextField();
    updateItems();
 }

 const updateSingleFieldDimension = ev => {
   let objectSingleField = {
      name: ev.currentTarget.getAttribute('name'),
      index: ev.currentTarget.getAttribute('index'),
      value: ev.target.value
   }
   props.updateSingleFieldDimension(objectSingleField);
   props.updateTotalWidth();
 }

 const updateHeight = ev => {
   let height_value = ev.target.value;
   props.updateHeight(height_value);
   updateItems();
 }

 const deleteSingleFiled = ev => {
   props.deleteSingleFiled(ev.currentTarget.getAttribute('index'));
   props.updateTotalWidth();
   updateItems();
 }

const dimension_options = [
   {titel: 'Alle Elemente sind gleich breit'},
   {titel: 'Die Elemente sind unterschiedlich breit'}
]

const arrayRadioItems = [
   {labalValue: 'Gesamt', labelTitel: 'Gesamtlänge angeben'},
   {labalValue: 'Einzeln', labelTitel: 'Einzelne Elemente angeben'}
]

       return (
           <div className="step_wrapper">
             <h2 className="step_header">Wie möchten Sie Ihre Maße eingeben?</h2>
              <div className="step_icon_wrapper">
                 <div className="inner_masseMenge_wrapper">
                  <div className="textfield-wrapper">
                     <InputRadio
                        arial_label='Maße'
                        name='Maße'
                        value={dimension}
                        onChange={selectKindOfDimension}
                        arrayRadioItems={arrayRadioItems}
                     />
                     {dimension === 'Gesamt'?
                           <TextField
                              className="textfield-masse-quantity zaun_field"
                              label="Gesamtlänge (in m)"
                              type="number"
                              rowsMax={1}
                              value={total_dimension_width}
                              name="totalwidth"
                              onChange={updateTotalWidth}
                           >
                           </TextField>
                        : ''
                     }
                     {/*Einzelne Elemente*/}
                     {dimension === 'Einzeln'?
                        <>
                           <label className='label_description'>Bestimmen Sie hier die Art der Elemente</label>
                           <Textfield
                              className="textfield-masse-quantity zaun_field"
                              label="Bitte wählen Sie"
                              type="text"
                              select
                              rowsMax={1}
                              value={kind_dimension}
                              onChange={updateSingleTotalDimension}
                              array_options={dimension_options}
                           >
                           </Textfield>
                              <div className='zaun_field_wrapper'>
                                 <h3 className='field_titel'>Zaunfeld 1</h3>
                                 <div className='textfield-single-wrapper'>
                                    <TextField
                                       className="textfield-masse-quantity"
                                       label="Breite (in cm)"
                                       type="number"
                                       rowsMax={1}
                                       value={single_width}
                                       name="singlewidth"
                                       onChange={updateSingleDimension}
                                    >
                                    </TextField>
                                    <TextField
                                       className="textfield-masse-quantity"
                                       label="Stückzahl"
                                       type="number"
                                       rowsMax={1}
                                       value={single_piece}
                                       name="single_piece"
                                       onChange={updateSingleDimension}
                                    >
                                    </TextField>
                                 </div>
                              </div>
                           {kind_dimension === 'Die Elemente sind unterschiedlich breit'?
                             single_fields.map((elem, index) => (
                                  <div className='zaun_field_wrapper' key={index}>
                                    <h3 className='field_titel'>Zaunfeld {index+2}</h3>
                                    <DeleteForeverIcon onClick={deleteSingleFiled} index={index} className='delete-icon' />
                                    <div className='textfield-single-wrapper index-wrapper' identindex={index}>
                                       <TextField
                                          className="textfield-masse-quantity"
                                          label="Breite (in cm)"
                                          type="number"
                                          rowsMax={1}
                                          value={elem.width}
                                          name="singlewidth"
                                          inputProps={{index: index}}
                                          onChange={updateSingleFieldDimension}
                                       >
                                       </TextField>
                                       <TextField
                                          className="textfield-masse-quantity"
                                          label="Stückzahl"
                                          type="number"
                                          rowsMax={1}
                                          value={elem.piece}
                                          name="single_piece"
                                          inputProps={{index: index}}
                                          onChange={updateSingleFieldDimension}
                                       >
                                       </TextField>
                                    </div>
                                 </div>
                              ))
                           :''
                           }
                           {kind_dimension === 'Die Elemente sind unterschiedlich breit'?
                             <Button className='addButton' onClick={addSingleTextField} startIcon={<AddCircleIcon />}>Weiteres Feld hinzufügen</Button> : ''
                           }
                        </>
                        : ''
                     }
                     {dimension === 'Gesamt'||dimension === 'Einzeln'?
                        <TextField
                              className="textfield-masse-quantity zaun_field"
                              label="Höhe (in cm)"
                              type="number"
                              rowsMax={1}
                              value={total_dimension_height}
                              name="totalheight"
                              onChange={updateHeight}
                           >
                        </TextField>
                        :''
                     }
                  </div>
                </div>
            </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
         data: state.zauneReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      dimensionKind: ev => dispatch(dimensionKindZaun(ev)),
      updateTotalWidth: ev => dispatch(updateTotalWidthZaun(ev)),
      updateSingleTotalDimension: ev => dispatch(updateSingleTotalDimensionZaun(ev)),
      updateSingleDimension: ev => dispatch(updateSingleDimensionZaun(ev)),
      addSingleTextField: ev => dispatch(addSingleTextFieldZaun(ev)),
      updateSingleFieldDimension: ev => dispatch(updateSingleFieldDimensionZaun(ev)),
      deleteSingleFiled: ev => dispatch(deleteSingleFiledZaun(ev)),
      updateStepsZaun: ev => dispatch(updateStepsZaun(ev)),
      updateHeight: ev => dispatch(updateHeightZaun(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_2);
